import {Component} from 'react';
import PropTypes from 'prop-types';

export default class ErrorBoundary extends Component {
    constructor(props) {
        super(props);
        this.state = {hasError: false};
    }

    static getDerivedStateFromError() {
        return {hasError: true};
    }

    componentDidCatch(error, info) {
        console.error('[ErrorBoundary]', error, info?.componentStack);
    }

    handleRetry = () => {
        this.setState({hasError: false});
    };

    render() {
        if (this.state.hasError) {
            return (
                <div className="error-boundary" role="alert">
                    <p className="error-boundary-text">Checklists Guru is down. Enjoy your day off.</p>
                    <button className="error-boundary-retry" onClick={this.handleRetry}>
                        Try again
                    </button>
                </div>
            );
        }
        return this.props.children;
    }
}

ErrorBoundary.propTypes = {
    children: PropTypes.node.isRequired,
};
